import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Home from '../views/Home.vue'
import PageNotFound from '../views/404.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/projects/gameboy-emulator',
    name: 'GameBoyEmulator',
    component: () => import(/* webpackChunkName: "gameboyemulator" */ '../views/projects/GameBoyEmulator.vue')
  },
  {
    path: '/projects/imagemeta',
    name: 'ImageMeta',
    component: () => import(/* webpackChunkName: "imagemeta" */ '../views/projects/ImageMeta.vue')
  },
  {
    path: '/projects/twitchpeakhighlight',
    name: 'TwitchPeakHighlight',
    component: () => import(/* webpackChunkName: "twitchpeakhighlight" */ '../views/projects/TwitchPeakHighlight.vue')
  },
  {
    path: '/projects/pomo-focus',
    name: 'PomoFocus',
    component: () => import(/* webpackChunkName: "pomofocus" */ '../views/projects/PomoFocus.vue')
  },
  {
    path: '/projects/go-template-url-shortener',
    name: 'GoTemplateUrlShortener',
    component: () => import(/* webpackChunkName: "urlshortener" */ '../views/projects/UrlShortener.vue')
  },
  {
    path: '/projects/agile-octopus',
    name: 'AgileOctopus',
    component: () => import(/* webpackChunkName: "agileoctopus" */ '../views/projects/AgileOctopus.vue')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
